export const REGEX = {
  // GENERALES
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{12,}$/,
  postCode: /^\d{5}$/,
  phoneFormat: /^[+]?[\d\s().-]{7,20}$/,
  text: /^[A-Za-zAEIOUaeiouÑñ\s]+$/,                 // ✅ con ñ/Ñ y acentos
  user: /^[A-Za-z0-9 ._-Ññ]+$/,                      // ✅ incluye ñ/Ñ
  address: /^[A-Za-z0-9 .,_#/\-()AEIOUaeiouÑñ]+$/,   // ✅ incluye ñ/Ñ y acentos
  correo: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
  alphanumeric: /^[A-Za-z0-9Ññ]+$/,                  // ✅ incluye ñ/Ñ

  // ESPECIFICO
  gemp_abrev: /^[A-Za-zÑñ]{1,3}$/,                   // ✅ incluye ñ/Ñ
  gemp_name: /^[A-Za-zAEIOUaeiouÑñ\s]+$/,            // ✅ incluye ñ/Ñ y acentos
  cedula: /^\d{9}$/,
  registroSanitario: /([A-ZÑ]{1,3}-?\d{3,6}-?[A-Z0-9Ñ]{1,6})/, // ✅ Ñ en letras

  // UUID (v1 a v5)
  uuid: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
  identificacion: /^[A-Za-z0-9 ._-Ññ]{9}$/,          // ✅ incluye ñ/Ñ
};
